export default __webpack_public_path__ + "static/media/menu.272362b2.png";